export enum ControlPanelCategory {
    DNA_TEST = "dna_test",
    BLOOD_TEST = "blood_test",
    CLINICAL_HISTORY = "clinical_history",
    MEDICAL_EQUIPE = "medical_equipe",
    MEAL_PLAN = "meal_plan",
    HEALTH_PLAN = "health_plan",
    CHECK_UP = "check_up",
}